import { validatePattern } from '../validate/pattern';
import { validateMaxLength } from '../validate/maxlength';
import { validateMinLength } from '../validate/minlength';
import { validateRequired } from '../validate/required';
import { validateMax } from '../validate/max';
import { validateMin } from '../validate/min';

export function validateSubmit(inputs: Array<HTMLInputElement>): Array<boolean> {
    const errors = [];
    for (const el of inputs) {
        const minLen = parseInt(el.getAttribute('minlength') as string, 10);
        const maxLen = parseInt(el.getAttribute('maxlength') as string, 10);
        const min = parseInt(el.getAttribute('min') as string, 10);
        const max = parseInt(el.getAttribute('max') as string, 10);
        const pattern = el.getAttribute('pattern');
        const required = el.hasAttribute('required');
        if (!isNaN(minLen)) {
            errors.push(validateMinLength(el, minLen));
        }
        if (!isNaN(maxLen)) {
            errors.push(validateMaxLength(el, maxLen));
        }
        if (!isNaN(min)) {
            errors.push(validateMin(el, min));
        }
        if (!isNaN(max)) {
            errors.push(validateMax(el, max));
        }
        if (required) {
            errors.push(validateRequired(el));
        }
        if (pattern) {
            errors.push(validatePattern(el, new RegExp(pattern)));
        }
    }
    return errors;
}

export function liveValidateSubmit(form: HTMLFormElement) {
    form.addEventListener('submit', function (this: HTMLFormElement, e: Event) {
        this.querySelectorAll('input,select,textfield').forEach((item: HTMLInputElement) => {
            return item.classList.add('focus-visible');
        });
    });
}

export function autoFocusFirstOnSubmitError(form: HTMLFormElement) {
    const firstChild = form.querySelector<HTMLElement>('.focus-visible ~.visible')?.parentElement?.firstElementChild;
    if (firstChild instanceof HTMLInputElement || firstChild instanceof HTMLSelectElement || firstChild instanceof HTMLTextAreaElement) {
        firstChild?.focus({ preventScroll: false });
    }
}
